import { cn } from '../lib/cn';

/**
 * Brand mark — uses the official `waylo-icon.png` asset (lives in /public).
 * Keep the markup square; sizing is driven by the `size` prop in pixels.
 */
export function BrandMark({ size = 56, className }: { size?: number; className?: string }): JSX.Element {
  return (
    <img
      src="/waylo-icon.png"
      alt=""
      width={size}
      height={size}
      className={cn('block rounded-2xl object-cover', className)}
      style={{ width: size, height: size }}
    />
  );
}

export function Wordmark(): JSX.Element {
  return <h1 className="text-3xl font-extrabold text-brand-navy">Waylo</h1>;
}
